import { Box, Typography, getContrastRatio } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomButton from '../../../components/CustomButton'
import { useDispatch, useSelector } from 'react-redux'
import { updateReviewState } from '../../../redux/reviewSlice'
import CustomInput from '../../eventcreation/components/CustomInput'
import RevisionLogNote from './RevisionLogNote'
import HelpOutlinedIcon from '@mui/icons-material/HelpOutlined';
import CustomTooltip from '../../../components/CustomTooltip'
import usePermissions from '../../../hooks/usePermissions'
import { PERMISSION } from '../../../constants/constants'
import { createRevisionLog, getRevisionLogs } from '../actions'
import { useNavigate } from 'react-router-dom'
import { generateDarkColor, generateLighterContrastColor } from '../../../utils/commonServices'
// import { customTheme as theme } from '../../../theme/customTheme'
import useCustomTheme from '../../../theme/useCustomTheme'
import useRevisionActions from '../useRevisionActions'
import DeleteLogConfirmationPopup from './DeleteLogConfirmationPopup'


const RequestLog = (props) => {
  const {disabled} =props
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const commonReducer = useSelector((state) => state.root.commonReducer);
  const reviewEventReducer = useSelector((state) => state.reviewEventReducer);
  const permissionsReducer = useSelector((state) => state.permissionsReducer);
  const [text, setText] = useState("");
  const [hasPermission] = usePermissions()
  const [theme ] = useCustomTheme()
  const {updateLog} = useRevisionActions()
  const prevRevisionIdRef = React.useRef(null)
  // Store permission value once to avoid function call in dependency array
  const canViewNotes = permissionsReducer?.permissions_master?.[PERMISSION.PROJECT.REVISION.NOTES.VIEW]

  useEffect(()=> {
    // Clear cached logs when the revision changes or is absent for the new event
    const currentRevisionId = commonReducer?.event_details?.revision?.id ?? null;
    const revisionVideoId = commonReducer?.event_details?.revision?.revision_video_id;
    const currentVideoId = commonReducer?.event_details?.final_video_id;

    if (!currentRevisionId) {
      // No revision for this event — ensure logs are cleared
      console.info('RequestLog: clearing logs for event (no revision)', { event_id: commonReducer.production_event_id })
      dispatch(updateReviewState({ revision_logs: [] }))
      prevRevisionIdRef.current = null
      return
    }

    // Check if revision belongs to old video - if so, don't fetch logs yet
    if (revisionVideoId && currentVideoId && revisionVideoId !== currentVideoId) {
      console.info('RequestLog: skipping logs fetch - revision is for old video', { 
        revision_id: currentRevisionId,
        revision_video_id: revisionVideoId, 
        current_video_id: currentVideoId 
      })
      dispatch(updateReviewState({ revision_logs: [] }))
      prevRevisionIdRef.current = null
      return
    }

    // If revision id changed since last render, clear logs and fetch fresh logs
    if (prevRevisionIdRef.current !== currentRevisionId) {
      console.info('RequestLog: revision changed, clearing logs and fetching new ones', { event_id: commonReducer.production_event_id, revision_id: currentRevisionId })
      dispatch(updateReviewState({ revision_logs: [] }))
      prevRevisionIdRef.current = currentRevisionId
      if (canViewNotes) {
        // Always fetch logs for the revision, even if it is submitted (we want read-only visibility)
        getRevisionLogs(dispatch, navigate, {commonReducer});
      }
    }

  }, [commonReducer?.event_details?.revision?.id, commonReducer?.event_details?.revision?.revision_video_id, commonReducer?.event_details?.final_video_id, commonReducer.production_event_id, canViewNotes])

  useEffect(()=> {
   dispatch(updateReviewState({timestamp:'00:00'}))

  }, [])

  const saveToLogClickHandler = ()=>{
    if(text != "") {
      reviewEventReducer?.edit_flag === true ? updateLog( {id: reviewEventReducer?.log_id, param: { message: text, timestamp: reviewEventReducer.timestamp}}, clearRevisionInput) :
      createRevisionLog(dispatch, navigate, {commonReducer, reviewEventReducer}, {id: commonReducer.user_id, param: {revision_id: commonReducer.event_details.revision.id, message: text, timestamp: reviewEventReducer.timestamp}}, clearRevisionInput)
    }
   // dispatch(updateReviewState({request_changes: false}))
  }
const clearRevisionInput = ()=> {
  setText("");
}
  const isSubmitted = !!commonReducer?.event_details?.revision?.submitted
  const isReadOnly = !!disabled || isSubmitted

  const handleTextboxFocus = () => {
    dispatch(updateReviewState({ pause_video_for_log: true }))
  }

  return (
    <Box sx={{maxHeight:'600px',height:'100%',padding:'13px', display:'flex', flexDirection:'column' , }}>
        <Box className='flex a-center' textAlign='left' gap={1} sx={{marginBottom: {xs:'10px',md:'15px',lg:'20px',xl:'30px'}}}>
            <Typography sx={{fontWeight:600, fontFamily:'Rubik', color:'black', fontSize:{xs:'10px',md:'13px',lg:'14px',xl:'20px'}}}>Revisions Log</Typography>
        {
          !isReadOnly && <CustomTooltip title= "How to submit revisions?" placement = "right" >
             <HelpOutlinedIcon onClick={()=> dispatch(updateReviewState({open_change_request_tutorial_popup : true}))} sx={{fontSize:{xs:'12px',lg:'16px', xl:'20px'}, cursor:'pointer'}}/>
          </CustomTooltip>
        }    
       
        </Box>
        <Box component='div' textAlign='left' sx={{overflowY: 'scroll', height: '60%'}} mb={1}>
          { hasPermission(PERMISSION.PROJECT.REVISION.NOTES.VIEW) &&
            reviewEventReducer.revision_logs.map((log)=> {
              return <Box mt={1.5}>
             {log?.deleted === false && <RevisionLogNote disabled={isReadOnly} color={generateDarkColor(log, 'username')} userName={log.username} message = {log.message} timestamp={log.timestamp} setText={setText} id={log?.id} log={log}/>}
              </Box>
            })
          }
         
        </Box>
       {//hasPermission(PERMISSION.PROJECT.REVISION.NOTES.CREATE) && 
       <Box>
            <Box flexGrow='1' textAlign='left'  >
              <CustomInput type='timestamp' disabled = {isReadOnly || !hasPermission(PERMISSION.PROJECT.REVISION.NOTES.CREATE)} onChange={(e)=> setText(e.target.value)} value= {text} size='small' max={500} style={{backgroundColor:'white'}}  sx={{width:'100%', input:{}, }} placeholder='Type request to editor here…' onFocus={handleTextboxFocus}/>   
            </Box>
        
            <CustomButton 
                btnText='Save to Log'
                disabled = {isReadOnly || reviewEventReducer.is_loading || !hasPermission(PERMISSION.PROJECT.REVISION.NOTES.CREATE)}
                onClick={saveToLogClickHandler}
                color='button'
                variant='contained'  style={{borderRadius: '5px', color:  theme.palette.primary.main === ('#00d744' || '#00D744') ? '#00d744' :  getContrastRatio('#08231B', theme.palette.primary.main) > 4.5 ? `${theme.palette.primary.main}` : generateLighterContrastColor(theme.palette.primary.main),opacity: (isReadOnly || reviewEventReducer.is_loading || !hasPermission(PERMISSION.PROJECT.REVISION.NOTES.CREATE)) && 0.6 , textTransform:'none', minWidth: '92px' }} sx={{height:{xs:'18px',sm:'20px',md:'22px', lg:'23px', xl:'35px'}, width:'100%', fontSize:{xs:'10px',md:'10px',lg:'11px',xl:'16px'}, fontFamily:'Rubik', fontWeight:600}}/>
        </Box>}
        {reviewEventReducer?.delete_log_confirmation_popup && <DeleteLogConfirmationPopup/>}
    </Box>
  )
}

export default RequestLog